import { Component } from '@angular/core';
import { ButtonType, ShowConfirmDialogArgs } from '@services/dialog/dialog-service.interfaces';
import { DialogService } from '@services/dialog/dialog.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

    // region Fields and Initialization

    title: string;
    message: string;
    buttonType: ButtonType;
    confirmText: string | null;

    popupVisible: boolean = true;

    close: Subject<void> = new Subject();

    buttonTypeEnum = ButtonType;

    constructor(
        private dialog: DialogService
    ) {
    }

    init(args: ShowConfirmDialogArgs) {
        this.title = args.title;
        this.message = args.message.replace(/\n/g, '<br />');
        this.buttonType = args.buttonType;
        this.confirmText = args.confirmText;
    }

    // endregion

    // region Event handlers

    successClicked() {
        this.dialog.dialogConfirmed.next(true);
        this.closeDialog();
    }

    closeClicked() {
        this.dialog.dialogConfirmed.next(false);
        this.closeDialog();
    }

    closeDialog() {
        this.popupVisible = false;
        // Give some time before the viewref is cleared for the animation to go through
        setTimeout(() => this.close.next(), 300);
    }

    onHiding() {
        this.dialog.dialogConfirmed.next(false);
    }

    // endregion
}
